import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';
import type { Store } from '@warp-drive/core';
import type { AccountExtension as AccountModel } from 'tio-data/data/resources/account.ext';
import type { PersonExtension as PersonModel } from 'tio-data/data/resources/person.ext';

export default class AuthenticatedReimaginedLoansDetailRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;
  @service declare store: Store;

  async model(params: Record<string, unknown>) {
    const personId = this.sessionContext.user.person.id!;
    const accountId = params['account_id'] as string;

    const [personResult, employerContributions, dataSourceInfo] = await Promise.all([
      this.store.request(
        findRecord<PersonModel>('person', personId, {
          include: 'accounts.financial-institution,accounts.loans,accounts.postal-address',
          reload: true,
        })
      ),
      this.reimaginedData.fetchEmployerContributions(),
      this.reimaginedData.getDataSourceInfo(),
    ]);

    const { content: personContent } = personResult as { content: { data: PersonModel } };
    const person = personContent.data;
    const account = person.activeAccounts?.find((a: AccountModel) => a.id === accountId);

    return {
      account,
      person,
      accountId,
      employerContributions,
      dataSourceInfo,
    };
  }
}
